var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "64",
        "height": "64",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }, attrs)
    }, rest), children.concat([_c('defs', [_c('filter', {
      attrs: {
        "x": "-44.4%",
        "y": "-50%",
        "width": "188.7%",
        "height": "200.1%",
        "filterUnits": "objectBoundingBox",
        "id": "b"
      }
    }, [_c('feGaussianBlur', {
      attrs: {
        "stdDeviation": "3.261",
        "in": "SourceGraphic"
      }
    })]), _c('filter', {
      attrs: {
        "x": "-17.5%",
        "y": "-22.1%",
        "width": "135%",
        "height": "144.3%",
        "filterUnits": "objectBoundingBox",
        "id": "d"
      }
    }, [_c('feGaussianBlur', {
      attrs: {
        "stdDeviation": "3.5",
        "in": "SourceAlpha",
        "result": "shadowBlurInner1"
      }
    }), _c('feOffset', {
      attrs: {
        "dy": "-7",
        "in": "shadowBlurInner1",
        "result": "shadowOffsetInner1"
      }
    }), _c('feComposite', {
      attrs: {
        "in": "shadowOffsetInner1",
        "in2": "SourceAlpha",
        "operator": "arithmetic",
        "k2": "-1",
        "k3": "1",
        "result": "shadowInnerInner1"
      }
    }), _c('feColorMatrix', {
      attrs: {
        "values": "0 0 0 0 1 0 0 0 0 0.643137255 0 0 0 0 0.776470588 0 0 0 0.3 0",
        "in": "shadowInnerInner1"
      }
    })]), _c('linearGradient', {
      attrs: {
        "x1": "95.633%",
        "y1": "-12.694%",
        "x2": ".341%",
        "y2": "113.347%",
        "id": "a"
      }
    }, [_c('stop', {
      attrs: {
        "stop-color": "#D74F51",
        "offset": "0%"
      }
    }), _c('stop', {
      attrs: {
        "stop-color": "#F7B9B9",
        "offset": "100%"
      }
    })]), _c('rect', {
      attrs: {
        "id": "c",
        "x": "0",
        "y": "0",
        "width": "40",
        "height": "31.625",
        "rx": "4.892"
      }
    })]), _c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('rect', {
      attrs: {
        "width": "64",
        "height": "64",
        "rx": "4"
      }
    }), _c('g', {
      attrs: {
        "transform": "translate(9 11)"
      }
    }, [_c('ellipse', {
      attrs: {
        "fill": "url(#a)",
        "fill-rule": "nonzero",
        "cx": "29.472",
        "cy": "16.055",
        "rx": "16",
        "ry": "16.055"
      }
    }), _c('path', {
      attrs: {
        "d": "M19.06 1h16.017c3.877-.015 5.695 2.525 5.452 7.62v11.939l-21.47-.915L18.498 1h.561z",
        "fill": "#B40506",
        "filter": "url(#b)",
        "transform": "translate(0 11.375)"
      }
    }), _c('g', {
      attrs: {
        "transform": "translate(0 11.375)"
      }
    }, [_c('use', {
      attrs: {
        "fill-opacity": ".3",
        "fill": "#FFA4C6",
        "xlink:href": "#c"
      }
    }), _c('use', {
      attrs: {
        "fill": "#000",
        "filter": "url(#d)",
        "xlink:href": "#c"
      }
    }), _c('rect', {
      attrs: {
        "stroke-opacity": ".4",
        "stroke": "#FFF",
        "stroke-width": ".5",
        "stroke-linejoin": "square",
        "x": ".25",
        "y": ".25",
        "width": "39.5",
        "height": "31.125",
        "rx": "4.892"
      }
    })]), _c('g', {
      attrs: {
        "fill": "#FFF",
        "fill-rule": "nonzero"
      }
    }, [_c('path', {
      attrs: {
        "d": "M18.967 18.442c-4.202 0-7.64 3.45-7.64 7.666 0 4.217 3.438 7.667 7.64 7.667 4.203 0 7.64-3.45 7.64-7.667 0-4.255-3.437-7.666-7.64-7.666zm-2.826 3.641a2.056 2.056 0 00-.497.269c-.153.115-.306.23-.459.383-.114.115-.267.268-.343.422-.115.153-.191.345-.268.498-.076.153-.229.23-.382.153-.153-.076-.229-.23-.153-.383.077-.192.191-.422.344-.613.239-.391.566-.72.955-.959.191-.115.382-.23.612-.345.152-.076.343 0 .382.154.038.191-.039.345-.191.421zm7.907 6.785c-.19.422-.42.805-.764 1.15-.343.345-.726.614-1.146.767-.42.192-.878.268-1.375.268-.153 0-.306-.153-.306-.306 0-.154.115-.307.306-.307.382 0 .764-.077 1.146-.23.344-.153.688-.345.955-.652.306-.268.497-.613.65-.958.152-.345.229-.767.229-1.15 0-.153.153-.307.305-.307.153 0 .306.154.306.307a5.494 5.494 0 01-.306 1.418zm4.661 5.444l-2.14-2.224a1.098 1.098 0 00-.802-.345c-.305 0-.573.115-.802.345a1.16 1.16 0 000 1.649l2.14 2.223c.229.23.496.345.802.345.305 0 .573-.115.802-.345a1.16 1.16 0 000-1.648z"
      }
    })])])])]));
  }
};